export const BreakpointSm = { value: "640px" };
export const BreakpointMd = { value: "768px" };
export const BreakpointLg = { value: "1024px" };
export const BreakpointXl = { value: "1280px" };
export const BreakpointXxl = { value: "1536px" };
export const ColorBlue100 = { value: "#E0F2FF" };
export const ColorBlue200 = { value: "#B5DEFF" };
export const ColorBlue300 = { value: "#78BBFA" };
export const ColorBlue400 = { value: "#3892F3" };
export const ColorBlue500 = { value: "#0265DC" };
export const ColorBlue600 = { value: "#004491" };
export const ColorNeutral0 = { value: "#ffffff" };
export const ColorNeutral10 = { value: "#fcfcfc" };
export const ColorNeutral20 = { value: "#fafafa" };
export const ColorNeutral30 = { value: "#f7f7f7" };
export const ColorNeutral40 = { value: "#f5f5f5" };
export const ColorNeutral50 = { value: "#eeeeee" };
export const ColorNeutral60 = { value: "#dfe0e1" };
export const ColorNeutral70 = { value: "#bcbcbd" };
export const ColorNeutral80 = { value: "#949596" };
export const ColorNeutral90 = { value: "#737475" };
export const ColorNeutral100 = { value: "#606162" };
export const ColorNeutral200 = { value: "#444445" };
export const ColorNeutral300 = { value: "#2d2e31" };
export const ColorNeutral400 = { value: "#141414" };
export const ColorNeutral500 = { value: "#040404" };
export const ColorBlueGrey100 = { value: "#eaeff2" };
export const ColorBlueGrey200 = { value: "#d0d8dd" };
export const ColorBlueGrey300 = { value: "#b4c1c8" };
export const ColorBlueGrey400 = { value: "#8c9ca5" };
export const ColorBlueGrey500 = { value: "#6a7a85" };
export const ColorBlueGrey600 = { value: "#576671" };
export const ColorOrange100 = { value: "#ffeccc" };
export const ColorOrange200 = { value: "#fdd291" };
export const ColorOrange300 = { value: "#ffa037" };
export const ColorOrange400 = { value: "#e46f00" };
export const ColorOrange500 = { value: "#b14c00" };
export const ColorOrange600 = { value: "#7a2f00" };
export const ColorYellow100 = { value: "#fff9e2" };
export const ColorYellow200 = { value: "#fff0b1" };
export const ColorYellow300 = { value: "#ffe278" };
export const ColorYellow400 = { value: "#ffc902" };
export const ColorYellow500 = { value: "#ffbe00" };
export const ColorYellow600 = { value: "#de9500" };
export const ColorGreen100 = { value: "#CEF8E0" };
export const ColorGreen200 = { value: "#89ECBC" };
export const ColorGreen300 = { value: "#49CC93" };
export const ColorGreen400 = { value: "#15A46E" };
export const ColorGreen500 = { value: "#007A4D" };
export const ColorGreen600 = { value: "#005132" };
export const ColorCyan100 = { value: "#e3fcff" };
export const ColorCyan200 = { value: "#b1f3fa" };
export const ColorCyan300 = { value: "#13ceea" };
export const ColorCyan400 = { value: "#08bfdf" };
export const ColorCyan500 = { value: "#0ca5c0" };
export const ColorCyan600 = { value: "#038299" };
export const ColorPurple100 = { value: "#f1edff" };
export const ColorPurple200 = { value: "#c1b6f2" };
export const ColorPurple300 = { value: "#8772e5" };
export const ColorPurple400 = { value: "#6954c0" };
export const ColorPurple500 = { value: "#4f3a9e" };
export const ColorPurple600 = { value: "#422799" };
export const ColorRed100 = { value: "#ffece9" };
export const ColorRed200 = { value: "#ffb2a0" };
export const ColorRed300 = { value: "#ff745f" };
export const ColorRed400 = { value: "#f94d32" };
export const ColorRed500 = { value: "#e13212" };
export const ColorRed600 = { value: "#bf2a00" };
export const ColorMagenta100 = { value: "#fbeaf5" };
export const ColorMagenta200 = { value: "#faafe2" };
export const ColorMagenta300 = { value: "#d949a9" };
export const ColorMagenta400 = { value: "#b52d88" };
export const ColorMagenta500 = { value: "#982071" };
export const ColorMagenta600 = { value: "#7d165b" };
export const Duration = { value: "200ms" };
export const DurationInstant = { value: "0ms" };
export const DurationFast = { value: "100ms" };
export const DurationSlow = { value: "300ms" };
export const FontFamilyBase = { value: "'Nunito Sans', sans-serif" };
export const FontFamilyDisplay = { value: "'Sofia Pro', SofiaPro, sans-serif" };
export const FontLineHeightBase = { value: "1.5" };
export const FontLineHeightDisplay = { value: "1.25" };
export const FontWeightNormal = { value: "400" };
export const FontWeightSemibold = { value: "600" };
export const FontWeightBold = { value: "700" };
export const FontSize100 = { value: "0.625rem" };
export const FontSize200 = { value: "0.75rem" };
export const FontSize300 = { value: "0.875rem" };
export const FontSize400 = { value: "1rem" };
export const FontSize500 = { value: "1.25rem" };
export const FontSize600 = { value: "1.5rem" };
export const FontSize700 = { value: "1.75rem" };
export const FontSize800 = { value: "2rem" };
export const FontSize900 = { value: "2.25rem" };
export const Radius0 = { value: "0" };
export const Radius1 = { value: "0.1875rem" };
export const Radius2 = { value: "0.375rem" };
export const Radius3 = { value: "0.5625rem" };
export const Radius4 = { value: "0.75rem" };
export const Radius5 = { value: "0.9375rem" };
export const Radius6 = { value: "1.125rem" };
export const Radius7 = { value: "1.3125rem" };
export const Radius8 = { value: "1.5rem" };
export const Size0 = { value: "0rem" };
export const Size1 = { value: "0.25rem" };
export const Size2 = { value: "0.5rem" };
export const Size3 = { value: "0.75rem" };
export const Size4 = { value: "1rem" };
export const Size5 = { value: "1.25rem" };
export const Size6 = { value: "1.5rem" };
export const Size7 = { value: "1.75rem" };
export const Size8 = { value: "2rem" };
export const Size9 = { value: "2.25rem" };
export const Size10 = { value: "2.5rem" };
export const Size11 = { value: "2.75rem" };
export const Size12 = { value: "3rem" };
export const Size13 = { value: "3.25rem" };
export const Size14 = { value: "3.5rem" };
export const SizeQuarter = { value: "0.0625rem" };
export const SizeHalf = { value: "0.125rem" };
export const TransitionEase = { value: "cubic-bezier(.4, 0, .2, 1)" };
export const TransitionEaseIn = { value: "cubic-bezier(.4, 0, 1, 1)" };
export const TransitionEaseOut = { value: "cubic-bezier(0, 0, .4, 1)" };
export const TransitionEaseInOut = { value: "cubic-bezier(.4, 0, .6, 1)" };